import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { rootReducer } from '@/store';
import { localStorageSyncReducer } from '@/store/layout/layout-reducers';
import { CalendarEffects } from '@/store/calendar/calendar.effects';
import { provideEffects } from '@ngrx/effects';
import { AuthenticationEffects } from '@/store/authentication/authentication.effects';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { DecimalPipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { BrowserModule } from '@angular/platform-browser';
import { JwtInterceptor } from '@core/helper/jwt.interceptor';
import { ErrorInterceptor } from '@core/helper/error.interceptor';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { CompanyEffects } from '@/store/company/company.effects';
import { DepartmentEffects } from '@/store/department/department.effects';
import { provideToastr } from 'ngx-toastr';
import { EmployeeEffects } from '@/store/employee/employee.effects';
import { CustomerEffects } from '@/store/customer/customer.effects';
import { PropertyEffects } from '@/store/property/property.effects';
import { HolidayEffects } from '@/store/holiday/holiday.effects';
import { TimesheetEffects } from '@/store/timesheet/timesheet.effects';
import { RoleEffects } from '@/store/roles/roles.effects';
import { ExpenseEffects } from '@/store/expense/expense.effects';
import { DashboardEffects } from '@/store/dashboard/dashboard.effects';
import { ReportEffects } from '@/store/report/report.effects';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '@core/helper/ngb-custom-date-parser';
import { MasterEffects } from '@/store/configuration/configuration.effects';
import { VehicleCheckEffects } from '@/store/fleet/vehicle-check/vehicle-check.effects';
import { VehicleEffects } from '@/store/fleet/vehicle/vehicle.effects';
import { ItAssetsConfigurationEffects } from '@/store/itassets-configuration/itAssets-configuration.effects';
import { ItAssetsEffects } from '@/store/itassets/itassets.effects';
import { ParkingManagementEffects } from '@/store/parking-managment/parking-managment.effects';
import { ParkingManagementConfigurationEffects } from '@/store/parking-managment-configuration/parking-management-configuration.effects';
import { DocumentTypeEffects } from '@/store/configuration/document-type/document-type.effects';
import { HolidayTypeEffects } from '@/store/holiday-type/holiday-type.effects';
import { DocumentEffects } from '@/store/employee/document/document.effects';
import { SOREffects } from '@/store/configuration/SOR/sor.effects';
import { TicksheetEffects } from '@/store/ticksheet/ticksheet.effects';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient
) => new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    DecimalPipe,
    CookieService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore(rootReducer, { metaReducers: [localStorageSyncReducer] }),
    importProvidersFrom(BrowserAnimationsModule, BrowserModule),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideEffects(
      AuthenticationEffects,
      CalendarEffects,
      CompanyEffects,
      DepartmentEffects,
      EmployeeEffects,
      CustomerEffects,
      PropertyEffects,
      HolidayEffects,
      TimesheetEffects,
      RoleEffects,
      ExpenseEffects,
      DashboardEffects,
      ReportEffects,
      MasterEffects, // Configuration
      VehicleCheckEffects,
      VehicleEffects,
      ItAssetsConfigurationEffects,
      ItAssetsEffects,
      ParkingManagementEffects,
      ParkingManagementConfigurationEffects,
      DocumentTypeEffects,
      HolidayTypeEffects,
      DocumentEffects,
      SOREffects,
      TicksheetEffects
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideToastr(),
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
};
